// extracted by mini-css-extract-plugin
export default {"bar":"SocialBar_bar__petad","button":"SocialBar_button__sXc0a","icon":"SocialBar_icon__yXR8u"};